import { Avatar } from './components/Avatar';
import { Checkbox } from './components/Checkbox';
import { Button } from './components/button';
import { MobileButton } from './components/mobileButton';
import { Text } from './components/text';
import { Input } from './components/Input';
import { Textarea } from './components/Textarea';
import { Menu } from './components/Menu';
import { Modal } from './components/Modal';
import { Switch } from './components/Switch';
import { Popover } from './components/popover';
import { Progress } from './components/Progress';

import { fontSizes } from './foundations/fontSizes';
import { colors } from './foundations/colors';
import { space } from './foundations/space';
import { boxShadow } from './foundations/box-shadow';
import { RadioButton } from './components/radioButton';
import { tooltipTheme } from './components/ToolTip';
import { fontWeights } from './foundations/fontWeights';
import { buildDarkModeStyles } from './colorMode/darkModeStyles';
const fontFamily = {
  primary: 'Inter, system-ui, sans-serif',
};

const fonts = {
  body: 'Inter, system-ui, sans-serif',
  heading: 'Inter, system-ui, sans-serif',
};

const config = {
  initialColorMode: 'light',
  cssVarPrefix: 'kula',
};

const radii = {
  xs: '6px',
  sm: '8px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  28: '28px',
  32: '32px',
  36: '36px',
};

const shadows = {
  primary: '0px 4px 12px 6px rgb(46 47 48 / 6%)',
  ...boxShadow,
};

// Built once: ~300 variables, and `global` runs on every GlobalStyle render.
const DARK_MODE_STYLES = buildDarkModeStyles();

const theme = {
  styles: {
    global: () => ({
      'html, body': {
        height: '100%',
        bg: 'white',
        color: 'secondary-700',
        overflow: 'hidden',
        margin: 0,
        padding: 0,
      },
      body: {
        overflowY: 'hidden',
        height: '100%',
        margin: 0,
        padding: 0,
      },

      'p a': {
        color: '#0043CE',
      },
      '.chakra-collapse': {
        height: '100% !important',
      },
      ':not(.chakra-dont-set-collapse) > .chakra-collapse': {
        overflow: 'initial !important',
      },
      // Inert unless <html data-kula-theme="dark"> (see theme/colorMode).
      ...DARK_MODE_STYLES,
    }),
  },
};

export const customTheme = {
  ...theme,
  config,
  colors,
  space,
  spacing: space,
  fontFamily,
  fonts,
  fontSizes,
  radii,
  shadows,
  fontWeights,
  components: {
    Button: {
      ...Button,
      variants: {
        ...Button.variants,
        ...MobileButton.variants,
      },
    },
    Avatar,
    Popover,
    Checkbox,
    Text,
    Input,
    Menu,
    Textarea,
    Modal,
    Switch,
    Radio: RadioButton,
    Tooltip: tooltipTheme,
    Progress,
    FormLabel: {
      baseStyle: {
        color: 'secondary-900',
        fontWeight: 'semiBold',
        fontSize: '14px',
        mb: '4px',
      },
    },
  },
};
